import { IConfiguredProductData } from 'pages/ConfigurePage/ConfigureForm/hooks';
import apiClient from 'services/api/apiService';
import { getUrlWithQueryParams } from './api/getUrlWithQueryParams';

const BASE_URL = '/v1/external';

// Submission status types for async processing. `unknown` is final: the lines
// may or may not have reached the supplier, Logyx core is checking, and the
// intent cannot be submitted again (logix-core docs/ordering.md, "Intents").
export type SubmissionStatus =
  | 'pending'
  | 'processing'
  | 'success'
  | 'failed'
  | 'unknown';

export interface ISubmitConfigurationResponse {
  intent_uuid: string;
  status: SubmissionStatus;
  task_id?: string;
}

export interface IIntentStatusResponse {
  status: SubmissionStatus;
  message: string | null;
}

export const submitConfiguration = async (
  configurationData: IConfiguredProductData,
  base64Metadata?: string
): Promise<ISubmitConfigurationResponse> => {
  const url = `${BASE_URL}/submit-configuration`;
  const { data } = await apiClient.post<{ data: ISubmitConfigurationResponse }>(
    url,
    { data: configurationData, base64_metadata: base64Metadata },
    {
      headers: {
        'Content-type': 'application/json',
      },
    }
  );
  return data.data;
};

export const getIntentStatus = async (): Promise<IIntentStatusResponse> => {
  const url = `${BASE_URL}/intent-status`;
  const { data } = await apiClient.get<{ data: IIntentStatusResponse }>(url, {
    headers: {
      'Content-type': 'application/json',
    },
  });
  return data.data;
};

export const getEditConfiguration = async (
  base64Metadata?: string
): Promise<any> => {
  const url = `${BASE_URL}/get-edit-configuration`;
  const queryParamsObj = {
    base64_metadata: base64Metadata,
  };
  const fullUrl = getUrlWithQueryParams(url, queryParamsObj);
  const { data } = await apiClient.get<any>(fullUrl, {
    headers: {
      'Content-type': 'application/json',
    },
  });

  return data.data;
};
